import dayjs from "dayjs";

export function formatDate(date = new Date(), format = "DD-MM-YYYY, hh:mm A") {
  return dayjs(date).format(format);
}

